import classNames from "classnames";
import type { ComponentPropsWithoutRef } from "react";

export type DescriptionProps = {
  variant?: "error" | "success" | "hint";
} & ComponentPropsWithoutRef<"div">;

const variants = {
  error: "text-error-500",
  success: "text-success-500",
  hint: "text-gray-600",
};

export default function Description({
  variant = "hint",
  className,
  ...props
}: DescriptionProps) {
  return (
    <div
      className={classNames(
        "text-sm wrap-break-word",
        variants[variant],
        className,
      )}
      {...props}
    />
  );
}
